<template>
  <div class="login">
    <p class="log-title">密码重置</p>
    <div :class="schoolCode=='13988'?'log-logo_13988':'log-logo'">
      <img v-if="schoolCode == '12343'" src="../../static/logo/logo_12343.png" alt="" />
      <img v-else-if="schoolCode == '10541'" src="../../static/logo/logo_10541.png" alt="" />
      <img v-else-if="schoolCode == '10045'" src="../../static/logo/logo_10045.jpg" alt="" />
      <img v-else-if="schoolCode == '13988'" src="../../static/logo/logo_13988_new.png" alt="" />
      <img style="width:85%" v-else-if="schoolCode == '12845'" src="../../static/logo/logo_12845.jpg" alt="" />
      <span class="bzy_class" v-else-if="schoolCode == '13899'" >
        <h4>北京中医药大学东方学院</h4>
        <h4>教务系统</h4>
        <img src="../../static/logo/logo_13899.jpg" alt="" />
      </span>
      <img v-else src="../../static/img/logo.png" alt="" />
    </div>

    <div class="log-input">
      <p>学号/工号</p>
      <div :class="isFocus[0]==true ? 'input-active' : 'input-item'">
        <input
          type="text"
          placeholder="请输入学号/工号"
          v-model.trim="account"
          autocomplete="user"
          @focus="lineChange(0)"
          @keyup.enter="next()"
          :disabled="seq!=0"
        />
        <i class="delete-icon" v-if="account && seq==0" @click="deleteTap(0)"></i>
      </div>
    </div>
    <!--      身份证方式-->
    <div v-if="seq == 1" class="log-input">
      <p>身份证件号</p>
      <div :class="isFocus[1]==true  ? 'input-active' : 'input-item  '">
        <input
          type="text"
          placeholder="请输入身份证件号"
          v-model.trim="sfzjh"
          autocomplete="psw"
          @focus="lineChange(1)"
          @keyup.enter="next()"
        />
        <i class="delete-icon" v-if="sfzjh" @click="deleteTap(1)"></i>
      </div>
    </div>
    <!--      问题方式-->
    <div v-if="seq == 2 && schoolCode != '8804'">
      <div class="log-input" v-if="retrievePwdData.wdt[0].value">
        <p>问题1:{{retrievePwdData.wdt[0].value}}</p>
        <div :class="isFocus[2]==true? 'input-active' : 'input-item  '">
          <input
            type="text"
            placeholder="请输入答案"
            v-model.trim="answer1"
            autocomplete="psw"
            @focus="lineChange(2)"
            @keyup.enter="next()"
          />
          <i class="delete-icon" v-if="answer1" @click="deleteTap(2)"></i>
        </div>
      </div>
      <div class="log-input" v-if="retrievePwdData.wdt[1].value">
        <p>问题{{retrievePwdData.wdt[0].value==''?'1':'2'}}:{{retrievePwdData.wdt[1].value}}</p>
        <div :class="isFocus[3]==true? 'input-active' : 'input-item  '">
          <input
            type="text"
            placeholder="请输入答案"
            v-model.trim="answer2"
            autocomplete="psw"
            @focus="lineChange(3)"
            @keyup.enter="next()"
          />
          <i class="delete-icon" v-if="answer2" @click="deleteTap(3)"></i>
        </div>
      </div>
    </div>
<!--      底部按钮-->
    <div class="log-btn">
        <button @click="previous()" :class="schoolCode == '13988'?'dban_13988':'dban'">{{this.leftText}}</button>


      <button @click="next('1')" :class="schoolCode == '13988'?'dban_13988':'dban'" v-if="this.retrievePwdType=='2'&&this.seq=='2'">邮箱重置</button>


        <button @click="next('0')" :class="schoolCode == '13988'?'dban_13988':'dban'" v-if="rigbtn">{{this.rightText}}</button>
      </div>

  </div>
</template>

<script>
import { Api } from "../utils/axios";

import service from "@/utils/request";
export default {
  data() {
    return {
      account: "",
      publicPath: process.env.BASE_URL,
      sfzjh: "",
      answer1:"",
      answer2:"",
      isFocus: [false,false,false,false],
      schoolCode: "",
      leftText:"取消",
      rightText:"下一步",
      seq:0,
      sfzfs:false,//身份证方式找回
      wdtfs:false,//问答题方式找回
      retrievePwdType:"",
      rigbtn: true,
      retrievePwdData:[],
        czmm:""
    };
  },
  beforeCreate() {
    sessionStorage.setItem("menuSave", 0);
    sessionStorage.setItem("ifSelect", 0);
  },
  created() {
    let sccd = sessionStorage.getItem("schoolCode");
    if(!sccd||sccd==''){
       this.getSchoolCode();
    }else{
      this.schoolCode = sccd;
    }
  },
  methods: {
    getPwdKey(){
      let monthVal = new Date().getMonth();
      if(monthVal>=9){
        monthVal = monthVal+1;
      }else{
        monthVal = "0"+(monthVal+1);
      }
      let dateVal = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
      let keyArr = [];
      keyArr.push(new Date().getFullYear());
      keyArr.push(monthVal);
      keyArr.push(dateVal);
      let strpwd = "";
      let pwdPosion = "";
      for(let i=0;i<3;i++){
        let rndNb = Math.ceil(Math.random()*9);
        pwdPosion+=rndNb;
        for(let k=0;k<rndNb*1;k++){
          strpwd+=Math.ceil(Math.random()*9);
        }
        strpwd+=keyArr[i];
      }
      strpwd+=pwdPosion;
      return strpwd;
    },
    async ss() {
      let keyStr = this.getPwdKey();
      const params = {
        'parmKeid' :keyStr
      };
      const code = await Api.getSchoolCode();
      sessionStorage.setItem("schoolCode", code.data.schoolcode);
      this.schoolcode = code.data.schoolcode;
    },
    deleteTap(val) {
      if (val == 0) {
        this.account = "";
      }
      else if (val == 1){
        this.sfzjh = "";
      }
      else if (val == 2){
          this.answer1 = "";
      }
      else if (val == 3){
          this.answer2 = "";
      }
    },
    async getSchoolCode() {
      let keyStr = this.getPwdKey();
      const params = {
        'parmKeid' :keyStr
      };
      const res = await Api.getSchoolCode(params);
      sessionStorage.setItem("schoolCode", res.data.schoolcode);
      this.schoolCode = sessionStorage.getItem("schoolCode");
    },
    lineChange(res) {
        for(var i=0;i<this.isFocus.length;i++){
            if(res==i){
                this.isFocus[i]=true;
            }
            else{
                this.isFocus[i]=false;
            }
        }
    },
    previous(){
        if(this.leftText=="取消"){
            this.$router.push("/login");
        }
        else if(this.seq==1){
            this.rightText="下一步";
            this.leftText="取消";
            this.seq=0;
        }
        else if(this.seq==2){
            if(this.retrievePwdType=="2"){
                this.rightText="下一步";
                this.leftText="上一步";
                this.seq=1;
            }
            else{
                this.rightText="下一步";
                this.leftText="取消";
                this.seq=0;
            }
        }

    },
    async next(type) {
        if (this.seq == 0) {
            if (this.rightText == "下一步") {
                if (this.account == "") {
                    this.$toast.fail("请输入账号");
                    return;
                }
                let params = {
                    account: this.account,
                    type:"csh"
                };
                const res = await Api.getRetrievePwdData(params);
                if (res.code == "0") {
                    return false;
                }
                this.retrievePwdType=res.retrievePwdType
                this.czmm=res.czmm
                this.retrievePwdData=res
                if(this.schoolCode == '8804'){
                  this.seq = 2;
                  this.retrievePwdType = '2';
                  this.rigbtn = false;
                }else{
                  //身份证
                  if (this.retrievePwdType == "0") {
                      this.rightText = "密码重置";
                      this.leftText = "上一步";
                      this.seq = 1;
                  }
                  // 问题
                  else if (this.retrievePwdType == "1") {
                      if(res.wdt.length<1){
                          this.$toast.fail("该帐号没有设置密码找回信息，无法完成该操作!");
                          return false;
                      }
                      this.rightText = "密码重置";
                      this.leftText = "上一步";
                      this.seq = 2;
                  }
                  // 组合
                  else {
                      this.rightText = "下一步";
                      this.leftText = "上一步";
                      this.seq = 1;
                  }
                }
                
            }
        }
        else if (this.seq == 1) {
            if (this.rightText == "下一步"||this.rightText == "密码重置") {
                //验证身份证
                if (this.sfzjh == "") {
                    this.$toast.fail("请输入身份证件号");
                    return;
                }
                let params = {
                    account: this.account,
                    sfzjh: this.sfzjh,
                    type: "sfzjh",
                    czmm:this.retrievePwdData.czmm
                };
                const res = await Api.getRetrievePwdData(params);
                if (res.code == "0") {
                    return false;
                }
                //只有身份证验证
                if(this.retrievePwdType=="0"&&res.code == "1"){
                    this.$toast.success(res.Msg);
                    setTimeout(() => {
                        this.$router.replace({
                            path: "/login"
                        });
                    }, 1500);
                    return false;
                }
                //组合
                else if(this.retrievePwdType=="2"&&res.code == "1"){
                    this.$toast.success(res.Msg);
                    setTimeout(() => {
                        this.rightText = "密码重置";
                        this.leftText = "上一步";
                        this.seq = 2;
                    }, 1500);
                    return false;
                }
                else{
                    this.$toast.fail("非法操作!");
                    setTimeout(() => {
                        this.$router.replace({
                            path: "/login"
                        });
                    }, 1500);
                    return false;
                }
            }
        }
        else if (this.seq == 2){
            //验证身份证
            if(sessionStorage.getItem("schoolCode") != '8804'){
              if (this.answer1 == ""&&this.retrievePwdData.wdt[0].value!="") {
                this.$toast.fail("请输入问题1的答案");
                return;
              }
              else if (this.answer2 == ""&&this.retrievePwdData.wdt[1].value!="") {
                  this.$toast.fail("请输入问题"+(this.retrievePwdData.wdt[0].value==''?'1':'2')+"的答案");
                  return;
              }
            }
            
            let params = {
                account: this.account,
                sfzjh: this.sfzjh,
                type: "wdtyz",
                czmm:this.retrievePwdData.czmm,
                answer1:this.answer1,
                answer2:this.answer2,
                email:type
            };
            const res = await Api.getRetrievePwdData(params);
            if (res.code == "1") {
                this.$toast.success(res.Msg);
                setTimeout(() => {
                    this.$router.replace({
                        path: "/login"
                    });
                }, 1500);
                return false;
            }
        }

    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.login {
  .bzy_class{
    font-family:'aril';
    font-size: .1625rem;
    line-height: .275rem;
  }
  .log-title1{
    display: flex;
    width: 100%;
    align-items: center;
      justify-content: center;
    .log-titlechildren{
      display: block;
      font-size:1.3375rem;
      color: @attendance-color-1;
      font-weight: 550;
    }
  }
  .log-title {
    font-size:1.3375rem;
    color: @attendance-color-1;
    font-weight: 550;
    margin: -20px 36px 27px;
  }
  .log-logo {
    text-align: center;
    padding: 28px 0 49px;
    img {
      width: 77px;
      height: 77px;
    }
  }
  .log-input {
    padding: 0 36px;
    p {
      color: @attendance-color-2;
      margin-bottom: 11px;
    }
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      justify-content: space-between;
      margin-bottom: 24px;
      > input {
        font-size: 24px;
        color: @attendance-color-1;
        width: 90%;
        padding: 0 4px;
        background-color: @attendance-color-3;
        &::placeholder {
          font-size: 20px;
        }
      }
      i {
        background: url(../../static/img/delete.png) no-repeat center;
        width: 16px;
        height: 16px;
        background-size: 16px 16px;
      }
    }
    .input-item {
      border-bottom: 1px solid @attendance-border-color-3;
    }
    .input-active {
      border-bottom: 1px solid @attendance-color-2;
    }
  }
  .log-btn {
    text-align: center;
    padding: 0 1.25rem;
    button {
      background-color: @attendance-background-color-1;
      padding: 11px 0;
      width: 100%;
      color: @attendance-color-3;
      border-radius: 3px;
      margin-top: 33px;
    }
  }
  .imgclass{
    height: 30px;
    margin-left: 20px;
  }
}
.log-logo_13988{
  text-align: center;
  padding: 0px 0 49px;
  background-image:url("../../static/logo/bj_13988.png");
  background-size: 100% auto;
  background-repeat:no-repeat;
  min-height: 195px;
  img{
    width: 80%;
    margin-left: 0;
    left: 10%;
    top:35px;
    z-index: 999;
  }
}
  .dban{
    width: 100px!important;
  }
.dban_13988{
  width: 100px!important;
  background-color: #0189f9!important;
}
</style>



// WEBPACK FOOTER //
// src/components/retrievePwd.vue